
import { Switch, Route } from "react-router-dom";
import { Restaurant } from "../views/restaurant/view";
import { Meal } from "../views/meal/view";
import { Takeout } from "../views/statistics/takeout/view";
import { Taste } from "../views/statistics/taste/view";

import { Library } from "../views/food/library/view";
import { Release } from "../views/food/release/view";
import { Appiontment } from "../views/food/appiontment/view";
import { Evaluate } from "../views/food/evaluate/view";
import { TakeMeal } from "../views/food/takeMeal/view";

import { User } from "../views/user/view";
import { Dict } from "../views/dict/view";

import Error404 from "../views/404";
import UserIntegral from "@/views/user/view/details/userIntegral";
import ChefIntegral from "@/views/user/view/details/chefIntegral";

function AppRoute() {
    return (
        <Switch>
            <Route exact={true} path={"/restaurant"} key="2" component={Restaurant} />
            <Route exact={true} path={"/meal"} key="3" component={Meal} />

            <Route exact={true} path={"/food/library"} key="4-1" component={Library} />
            <Route exact={true} path={"/food/evaluate"} key="4-1-1" component={Evaluate} />
            <Route exact={true} path={"/food/release"} key="4-2" component={Release} />
            <Route exact={true} path={"/food/appointment"} key="4-3" component={Appiontment} />
            <Route exact={true} path={"/food/takeMeal"} key="4-5" component={TakeMeal} />

            <Route exact={true} path={"/statistics/takeout"} key="5-1" component={Takeout} />
            <Route exact={true} path={"/statistics/taste"} key="5-2" component={Taste} />

            <Route exact={true} path={"/user"} key="6" component={User} />
            <Route exact={true} path={"/user/integral"} key="6-1" component={UserIntegral} />
            <Route exact={true} path={"/chef/integral"} key="6-2" component={ChefIntegral} />
            <Route exact={true} path={"/dict"} key="7" component={Dict} />
            <Route exact={true} path={"/*"} key="404" component={Error404} />
        </Switch>
    )
}

export default AppRoute;